import React, { useState } from 'react'
import {
    CFormInput, CNav, CNavItem, CNavLink, CTabContent, CTabPane
} from "@coreui/react";
import TitleCopy from './TitleCopy';
import ReOrderTitle from '../../components/shared/ReOrderTitle';

const AddSuggestionTitle = ({ setNewTitle, newTitle, newCode, setNewCode, setParentAccordions, parentId, handelAutoSubmit, setModalVisible, addAccordion, LinkFor, ApiCallingType, handleSubmitWhenTabChange, differentModuleCopyFunctionality, type, accordions, showOrderTab = true, setShowTitleFooter }) => {
    const [activeTab, setActiveTab] = useState(0)

    const handleSubmit = () => {
        addAccordion(parentId);
        setModalVisible(false);

    }
    return (
        <div>
            <div className='pe-tab-underline-nav mb-4'>
                <CNav role="tablist" className="justify-content-center" >
                    <CNavItem>
                        <CNavLink active={activeTab === 0} onClick={() => {
                            setShowTitleFooter(true)
                            setActiveTab(0)
                        }}>
                            New Title
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink active={activeTab === 1} onClick={() => {
                            setActiveTab(1)
                            setShowTitleFooter(false)
                            handleSubmitWhenTabChange(false)
                        }}>
                            Copy Title
                        </CNavLink>
                    </CNavItem>
                    {showOrderTab && <CNavItem>
                        <CNavLink active={activeTab === 2} onClick={() => {
                            setShowTitleFooter(false)
                            setActiveTab(2)

                        }}>
                            Re-arrange
                        </CNavLink>
                    </CNavItem>}
                </CNav>
            </div>
            <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                <CTabContent>

                    {activeTab === 1 && <CTabPane visible={activeTab === 1}>
                        <TitleCopy setParentAccordions={setParentAccordions} parentId={parentId} setModalVisible={setModalVisible} LinkFor={LinkFor} ApiCallingType={ApiCallingType} type={type} differentModuleCopyFunctionality={differentModuleCopyFunctionality} />
                    </CTabPane >}
                    {activeTab === 0 && <CTabPane visible={activeTab === 0} className='d-flex flex-column justify-content-center align-items-center'>
                        <div className='w-75 p-3 rounded pe-title-card'>
                            <h2 className='font-weight-large mb-2' style={{ fontSize: '16px' }}>Title</h2>
                            <CFormInput
                                name='Title'
                                value={newTitle}
                                onChange={(e) => setNewTitle(e.target.value)}
                                type='text'
                                placeholder=''
                                className='h-25'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSubmit();
                                    }
                                }}
                            />
                            <h2 className='font-weight-large mb-2 mt-3' style={{ fontSize: '16px' }}>Code</h2>
                            <CFormInput
                                name='Code'
                                value={newCode}
                                onChange={(e) => setNewCode(e.target.value)}
                                type='text'
                                placeholder=''
                                className='h-25'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSubmit();
                                    }
                                }}
                            />
                        </div>
                    </CTabPane>}
                    {activeTab === 2 && <CTabPane visible={activeTab === 2}>
                        <ReOrderTitle setParentAccordions={setParentAccordions} parentId={parentId} accordions={accordions} setModalVisible={setModalVisible} setShowTitleFooter={setShowTitleFooter} />
                    </CTabPane >}
                </CTabContent>
            </div>

        </div>
    )
}

export default AddSuggestionTitle
